import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormInput,
  Form,
  SelectPaymentOptions,
} from "../../../../onestep-library/BaseUI";
import { Modal, Card } from "react-bootstrap";
import Scheduler from "./components/Scheduler";
import { submitMasterNewChargeForm } from "./actions";
import { injectStripe } from "react-stripe-elements";
import { validateMasterNewChargeForm } from "./utils";
import { buildOptions } from "./../../../../../../utils";
import { uniq } from "lodash";
import PaySimpleTransactionFee from "../PaySimpleTransactionFee";

function MasterNewChargeForm(props) {
  const dispatch = useDispatch();
  const paySimplePMTRef = React.useRef();
  const [paySimpleCardValid, setPaySimpleCardValid] = React.useState(true);
  const {
    masterNewChargeForm,
    organization,
    resident,
    paymentSources,
    current_user,
    occupancies,
  } = useSelector((state) => state);
  const {
    payment_source,
    ui,
    transaction_type,
    first_issue_date,
    ends_at,
    interval_count,
    interval,
    end_type,
    occurrences,
    has_credit_card_to_charge,
    did_the_client_already_pay,
    already_paid_payment_method,
    invoice_client,
    group_id,
    email,
    already_paid_amount,
    amount,
    due_days_after_invoice,
    due_date,
    memo,
    errors,
    first_due_date,
    receipt_email,
    receipt_note,
    send_receipt_to_client,
    overdue_invoice_reminder,
  } = masterNewChargeForm;
  const emailOptions = buildOptions(
    uniq([paymentSources.email, resident.email])
  );

  const occupancyGroupIds = occupancies.map((occupancy) => occupancy.group_id);
  const groupOptions = current_user.groups_from_policy
    .filter((group) => occupancyGroupIds.includes(group.id))
    .map((group) => ({ label: group.name, value: group.id }));
  const receiptEmailValue = emailOptions.find(
    (option) => option.value === receipt_email
  );
  const emailValue = emailOptions.find((option) => option.value === email);
  const { show, is_submitting } = ui;
  const [overdueReminderDays, setOverdueReminderDays] = React.useState([]);
  const updateMasterNewChargeFormField = (payload) =>
    dispatch({ type: "UPDATE_MASTER_CHARGE_FORM_FIELD", payload });

  function handleClose() {
    dispatch({ type: "RESET_MASTER_CHARGE_FORM" });
  }

  function onClose() {
    handleClose();
  }

  function onValidateRequiredFields() {
    return (
      validateMasterNewChargeForm(masterNewChargeForm) && paySimpleCardValid
    );
  }

  function handleClose() {
    setOverdueReminderDays([]);
    dispatch({ type: "RESET_MASTER_CHARGE_FORM" });
  }

  function handleOverdueReminderDaysChange(e) {
    const { value, checked } = e.target;
    const updatedDays = checked
      ? [...overdueReminderDays, value]
      : overdueReminderDays.filter((day) => day !== value);

    setOverdueReminderDays(updatedDays);
    updateMasterNewChargeFormField({ overdueReminderDays: updatedDays });
  }

  function onSubmit() {
    dispatch({ type: "BEGIN_SUBMIT_MASTER_CHARGE_FORM" });
    if (payment_source && payment_source.kind == "other_card") {
      organization.payment_processor == "paysimple" &&
        paySimplePMTRef.current.submit();
      organization.payment_processor == "stripe" && createNewPaymentSource();
    } else {
      dispatch(submitMasterNewChargeForm());
      setOverdueReminderDays([]);
    }
  }

  function handlePaySimplePaymentMethodSucceeded(paySimple) {
    $.ajax({
      url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources/create_pay_simple_card.json`,
      method: "POST",
      data: {
        payment_source: {
          kind: "card",
          pay_simple_token_id: paySimple.payment_method_token,
        },
      },
      success: (payment_source) => {
        dispatch({ type: "ADD_PAYMENT_SOURCE", payload: payment_source });
        dispatch(updateMasterNewChargeFormField({ payment_source }));
        dispatch(submitMasterNewChargeForm());
      },
      error: (xhr) => {
        const errors = $.parseJSON(xhr.responseText).errors;
        dispatch({ type: "FAILED_SUBMIT_NEW_PAYMENT_SOURCE", payload: errors });
      },
    });
  }

  function createNewPaymentSource() {
    if (organization.payment_processor == "paysimple") {
      paySimplePMTRef.current.submit();
    } else {
      props.stripe.createToken({ name: "Name" }).then((stripeResponse) => {
        if (stripeResponse.error) {
          dispatch({
            type: "FAILED_SUBMIT_MASTER_CHARGE_FORM",
            payload: [stripeResponse.error.message],
          });
        } else {
          $.ajax({
            url: `/organizations/${organization.name}/residents/${resident.id}/payment_sources.json`,
            method: "POST",
            data: {
              payment_source: {
                kind: "card",
                stripe_token_id: stripeResponse.token.id,
                stripe_source_id: stripeResponse.token.card.id,
                last4: stripeResponse.token.card.last4,
                brand: stripeResponse.token.card.brand,
              },
            },
            success: (payment_source) => {
              dispatch({ type: "ADD_PAYMENT_SOURCE", payload: payment_source });
              dispatch(updateMasterNewChargeFormField({ payment_source }));
              dispatch(submitMasterNewChargeForm(props.stripe));
            },
            error: (xhr) => {
              const errors = $.parseJSON(xhr.responseText).errors;
              dispatch({
                type: "FAILED_SUBMIT_MASTER_CHARGE_FORM",
                payload: errors,
              });
            },
          });
        }
      });
    }
  }

  function handleChangeClientAlreadyPaid(e) {
    updateMasterNewChargeFormField({
      did_the_client_already_pay: e.value,
      already_paid_payment_method: undefined,
      already_paid_amount: "no",
      due_days_after_invoice: undefined,
      already_paid_amount: undefined,
      invoice_client: "no",
      due_date: undefined,
      first_issue_date: undefined,
      email: undefined,
    });
    setOverdueReminderDays([]);
  }

  function handleChangeTransactionType(e) {
    updateMasterNewChargeFormField({
      payment_source:
        e.value == "recurring" &&
          payment_source &&
          payment_source.kind == "balance"
          ? null
          : payment_source,
      transaction_type: e.value,
      first_due_date: undefined,
      first_issue_date: undefined,
      due_date: undefined,
      ends_at: undefined,
      interval_count: undefined,
      interval: undefined,
      end_type: undefined,
      occurrences: undefined,
      did_the_client_already_pay: "no",
      already_paid_payment_method: undefined,
      already_paid_amount: undefined,
    });
    setOverdueReminderDays([]);
  }

  function handleChangeHasCreditCardToCharge(e) {
    setPaySimpleCardValid(true);
    updateMasterNewChargeFormField({
      has_credit_card_to_charge: e.value,
      due_date: undefined,
      did_the_client_already_pay: "no",
      already_paid_payment_method: "",
      already_paid_amount: "",
      invoice_client: "no",
      email: "",
      first_issue_date: undefined,
      payment_source: null,
      due_days_after_invoice: "",
    });
    setOverdueReminderDays([]);
  }

  function handleChangeInvoiceClient(e) {
    updateMasterNewChargeFormField({
      invoice_client: e.value,
      email: e.value == "yes" ? paymentSources.email : "",
      first_issue_date: undefined,
    });
  }

  function handleChangeReceiptClient(e) {
    updateMasterNewChargeFormField({
      send_receipt_to_client: e.value,
      receipt_email: e.value == "yes" ? paymentSources.email : ""
    });
  }

  function getRecurringChargeStepNumber() {
    return has_credit_card_to_charge == "yes"
      ? payment_source && payment_source.kind == "other_card"
        ? 5
        : 4
      : 4;
  }

  React.useEffect(() => {
    groupOptions.length == 1 &&
      updateMasterNewChargeFormField({ group_id: groupOptions[0].value });
  }, []);

  return (
    <Modal show={show} onHide={handleClose}>
      <Card.Header className="font-weight-bold">New</Card.Header>
      <Modal.Body>
        <Form
          show={show}
          title="New Recurring Transaction"
          isSubmitting={is_submitting}
          submitButtonLabel="Create"
          handleValidateRequiredFields={onValidateRequiredFields}
          errors={errors}
          handleClose={onClose}
          handleSubmit={onSubmit}
        >
          {current_user.groups_from_policy.length > 1 && (
            <FormInput
              label="Billing Facility"
              labelClassName="font-weight-bold"
              placeholder="Enter Facility"
              type="select"
              value={groupOptions.find((option) => option.value == group_id)}
              handleChange={(option) =>
                updateMasterNewChargeFormField({ group_id: option.value })
              }
              options={groupOptions}
            />
          )}
          <FormInput
            label="1. What is this for?"
            labelClassName="font-weight-bold"
            placeholder="Enter description..."
            value={memo}
            handleChange={(memo) => updateMasterNewChargeFormField({ memo })}
          />
          <FormInput
            label="2. How much is it for?"
            labelClassName="font-weight-bold"
            type="number"
            placeholder="Enter amount..."
            handleChange={(amount) =>
              updateMasterNewChargeFormField({ amount: Number(amount) })
            }
          />
          <FormInput
            label={`3. Is this a single (one time) transaction or a recurring transaction?`}
            labelClassName="font-weight-bold"
            type="select"
            placeholder="Select Single or Recurring..."
            options={[
              { label: "Single", value: "single" },
              { label: "Recurring", value: "recurring" },
            ]}
            handleChange={(e) => handleChangeTransactionType(e)}
          />
          {transaction_type == "recurring" && (
            <Scheduler
              useBoldLabels
              isInvoice={has_credit_card_to_charge == "no"}
              stepNumber={3}
              handleChange={updateMasterNewChargeFormField}
              first_issue_date={first_issue_date}
              first_due_date={first_due_date}
              ends_at={ends_at}
              interval_count={interval_count}
              interval={interval}
              end_type={end_type}
              occurrences={occurrences}
            />
          )}
          <FormInput
            label={
              !!organization.payment_processor
                ? `4. Will you be charging a credit card, bank account, or available funds${transaction_type == "single" ? " now" : ""
                }?`
                : "4. Will you be charging to the client's available funds?"
            }
            labelClassName="font-weight-bold"
            type="select"
            placeholder="Yes or No?.."
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
            handleChange={(e) => handleChangeHasCreditCardToCharge(e)}
          />
          {has_credit_card_to_charge == "yes" && (
            <div>
              <SelectPaymentOptions
                label="5. Select Payment Source"
                labelClassName="font-weight-bold"
                showNewPaymentMethodButton={false}
                hasOtherCardOption
                value={payment_source}
                hasBalanceOption={transaction_type != "recurring"}
                handlePaymentSourceChange={(payment_source) =>
                  updateMasterNewChargeFormField({ payment_source })
                }
                desc="Note: Pay With Available Funds is only available for single charges."
              />
              {payment_source && payment_source.kind == "other_card" && (
                <>
                  {organization.payment_processor == "paysimple" && (
                    <FormInput
                      ref={paySimplePMTRef}
                      setCardValidation={(bool) => setPaySimpleCardValid(bool)}
                      handlePaymentMethodSucceeded={
                        handlePaySimplePaymentMethodSucceeded
                      }
                      dispatchTypePaymentMethodFailed='FAILED_SUBMIT_MASTER_CHARGE_FORM'
                      label="6. Enter Credit Card Information"
                      labelClassName="font-weight-bold"
                      type="credit_card_paysimple"
                    />
                  )}
                  {organization.payment_processor == "stripe" && (
                    <FormInput type="credit_card_stripe" />
                  )}
                </>
              )}
              {payment_source && ['bank_account', 'other_card', 'card'].includes(payment_source.kind) && (
                <PaySimpleTransactionFee paymentSourceKind={payment_source.kind} />
              )}
            </div>
          )}
          {has_credit_card_to_charge == "no" && (
            <div>
              {transaction_type == "single" && (
                <FormInput
                  label="5. Did the client already pay you by other means (i.e. cash/check/other)?"
                  labelClassName="font-weight-bold"
                  type="select"
                  placeholder="Yes or No?.."
                  options={[
                    { label: "Yes", value: "yes" },
                    { label: "No", value: "no" },
                  ]}
                  handleChange={(e) => handleChangeClientAlreadyPaid(e)}
                />
              )}
              {did_the_client_already_pay == "yes" && (
                <FormInput
                  label="6. How was this paid for?"
                  labelClassName="font-weight-bold"
                  type="select"
                  placeholder="Select payment method..."
                  options={[
                    { label: "Cash", value: "cash" },
                    { label: "Check", value: "check" },
                    { label: "Cashapp", value: "cashapp" },
                    { label: "Venmo", value: "venmo" },
                    { label: "Stripe", value: "stripe" },
                    { label: "PayPal", value: "paypal" },
                    { label: "Money Order", value: "money_order" },
                    { label: "Zelle", value: "zelle" },
                    { label: "Vanco", value: "vanco" },
                    { label: "Other", value: "other" }
                  ]}
                  handleChange={(e) =>
                    updateMasterNewChargeFormField({
                      already_paid_payment_method: e.value,
                    })
                  }
                />
              )}
              {transaction_type == "single" &&
                did_the_client_already_pay == "no" &&
                has_credit_card_to_charge == "no" && (
                  <FormInput
                    type="date"
                    labelClassName="font-weight-bold"
                    label="6. When is payment due by?"
                    value={due_date}
                    handleChange={(due_date) =>
                      updateMasterNewChargeFormField({ due_date })
                    }
                    placeholder="Enter Due Date..."
                  />
                )}
              {(did_the_client_already_pay == "no" ||
                (has_credit_card_to_charge == "no" &&
                  transaction_type == "recurring")) && (
                  // !!organization.payment_processor && (
                  <FormInput
                    label={`${transaction_type == "recurring" ? 5 : 7
                      }. Would you like to email the client an invoice?`}
                    labelClassName="font-weight-bold"
                    type="select"
                    placeholder="Yes or No?.."
                    options={[
                      { label: "Yes", value: "yes" },
                      { label: "No", value: "no" },
                    ]}
                    handleChange={(e) => handleChangeInvoiceClient(e)}
                  />
                )}
              {invoice_client == "yes" &&
                (did_the_client_already_pay == "no" ||
                  transaction_type == "recurring") &&
                has_credit_card_to_charge == "no" && (
                  <div>
                    <FormInput
                      type="select"
                      isCreatable
                      label={`${transaction_type == "recurring" ? 6 : 8
                        }. Enter email address`}
                      labelClassName="font-weight-bold"
                      placeholder="example@me.com"
                      value={emailValue}
                      options={emailOptions}
                      handleChange={(email) =>
                        updateMasterNewChargeFormField({ email: email.value })
                      }
                    />
                    <FormInput
                      label={`${transaction_type == "recurring" ? 7 : 9
                        }. Invoice note`}
                      labelClassName="font-weight-bold"
                      placeholder="Enter in any notes or instructions you’d like to share within the client’s invoiced email"
                      value={receipt_note}
                      handleChange={(receipt_note) =>
                        updateMasterNewChargeFormField({ receipt_note: receipt_note })
                      }
                    />
                    {transaction_type == "recurring" && (
                      <FormInput
                        label={`${transaction_type == "recurring" ? 8 : 10
                          }. What day before the due date would you like to email the invoice?`}
                        labelClassName="font-weight-bold"
                        placeholder="Email invoice on...."
                        type="date"
                        value={first_issue_date}
                        handleChange={(first_issue_date) =>
                          updateMasterNewChargeFormField({ first_issue_date })
                        }
                      />
                    )}
                  </div>
                )}
            </div>
          )}
          {
            <>
              <FormInput
                label={`Would you like to email the client a receipt?`}
                labelClassName="font-weight-bold"
                type="select"
                placeholder="Yes or No?.."
                options={[
                  { label: "Yes", value: "yes" },
                  { label: "No", value: "no" },
                ]}
                handleChange={(e) => handleChangeReceiptClient(e)}
              />
              {send_receipt_to_client == "yes" && (
                <FormInput
                  type="select"
                  isCreatable
                  label="Enter email address"
                  labelClassName="font-weight-bold"
                  placeholder="example@me.com"
                  value={receiptEmailValue}
                  options={emailOptions}
                  handleChange={(receipt_email) =>
                    updateMasterNewChargeFormField({
                      receipt_email: receipt_email.value,
                    })
                  }
                />
              )}
              {has_credit_card_to_charge === "no" && invoice_client == "yes" && (
                <FormInput
                label={`Would you like to send email an overdue reminder to the client`}
                labelClassName="font-weight-bold"
                type="select"
                placeholder="Yes or No?.."
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
                handleChange={(e) => {
                  updateMasterNewChargeFormField({
                    overdue_invoice_reminder: e.value,
                  })
                }}
              />
              )}
              {overdue_invoice_reminder === true && (
                <div className="form-group">
                  <label className="font-weight-bold">
                    When would you like to send the overdue reminder emails to the client?
                  </label>
                  <div>
                    <input
                      type="checkbox"
                      value="1"
                      onChange={handleOverdueReminderDaysChange}
                    /> 1 day overdue
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      value="5"
                      onChange={handleOverdueReminderDaysChange}
                    /> 5 days overdue
                  </div>
                  <div>
                    <input
                      type="checkbox"
                      value="10"
                      onChange={handleOverdueReminderDaysChange}
                    /> 10 days overdue
                  </div>
                </div>
              )}
            </>
          }
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default injectStripe(MasterNewChargeForm);
